import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Radio } from 'antd';
import { parseStringOr, parseBoolOr } from '../../App/AppxUtils';


export default function InputCheckboxGroup(props) {
    const { t } = useTranslation('appxweb');
    const required = parseBoolOr(props.required, false);
    const label = parseStringOr(props.label, null);
    let rules = [];

    if (required) {
        let rule = {
            required: true,
        }

        if (label != null) {
            rule.message = t('AppxForm.input_required', {field: label});
        }

        rules.push(rule);
    }


    if (Array.isArray(props.rules) && props.rules.length > 0) {
        rules = [...rules, ...props.rules];
    }

    return (
        <Form.Item
            className={props.className}
            name={props.name}
            label={(props.showLabel === false) ? null : label}
            rules={rules}
            help={props.help}
            style={props.style}
        >
            <Radio.Group
                options={props.options}
                defaultValue={props.defaultValue}
                onChange={props.onChange}
                style={props.radioStyle}
                disabled={props.disabled}
            >
                {props.children}
            </Radio.Group>
        </Form.Item>
    );
}
